import CollectionSliderBase from './CollectionSliderBase';
export const CollectionSlider = {
  CollectionSlider_2_1: ({ item }) => {
    return <CollectionSliderBase item={item} imageWidth={45} aspectRatio={2 / 1}></CollectionSliderBase>;
  },
  CollectionSlider_1_5_2: ({ item }) => {
    return <CollectionSliderBase item={item} imageWidth={45} aspectRatio={3 / 4}></CollectionSliderBase>;
  },
  CollectionSlider_1_1_13: ({ item }) => {
    return <CollectionSliderBase item={item} imageWidth={13.333} aspectRatio={1 / 1}></CollectionSliderBase>;
  },
  CollectionSlider_1_1_22: ({ item }) => {
    return <CollectionSliderBase item={item} imageWidth={22} aspectRatio={1 / 1}></CollectionSliderBase>;
  },
  CollectionSlider_1_2_22: ({ item }) => {
    return <CollectionSliderBase item={item} imageWidth={22} aspectRatio={1 / 2}></CollectionSliderBase>;
  },
  CollectionSlider_1_1_30: ({ item }) => {
    return <CollectionSliderBase item={item} imageWidth={30} aspectRatio={1 / 1}></CollectionSliderBase>;
  },
  CollectionSlider_1_1_13_round: ({ item }) => {
    return (
      <CollectionSliderBase item={item} imageWidth={13.333} aspectRatio={1 / 1} rounded={true}></CollectionSliderBase>
    );
  },
  CollectionSlider_1_1_22_round: ({ item }) => {
    return <CollectionSliderBase item={item} imageWidth={22} aspectRatio={1 / 1} rounded={true}></CollectionSliderBase>;
  },
  CollectionSlider_1_1_30_round: ({ item }) => {
    return <CollectionSliderBase item={item} imageWidth={30} aspectRatio={1 / 1} rounded={true}></CollectionSliderBase>;
  },
  CollectionSlider_Petzzshop: ({ item }) => {
    return <CollectionSliderBase item={item} imageWidth={23} aspectRatio={1 / 1} rounded={true}></CollectionSliderBase>;
  },
};
